export default function LinkFieldTemplate(data) {
    return `
        <div class="k-mobile-wa position-relative _ref">
            <input class="w-100" autocomplete="off" type='text' ${data.style} id="${data.elementId}" nid="${data.id}"/>
            <div>
                <a class="k-select nama-ref-create" id="${data.elementId}linkGoTo" role="button"
                   tabindex="-1" title='${data.translateId("openLink")}'><i class="fa-solid fa-arrow-right text-secondary px-1"></i></a>
                </div>
        </div>`;
}